<div class="relative">
  <input type="checkbox" [formControl]="control" class="ag-checkbox ag-size-{{ size }}" [class.has-errors]="control?.invalid && control?.dirty" [class.disabled]="control?.disabled" />
  <img *ngIf="!control?.value" [src]="iconService.Icon.check" class="ag-checkbox-hover-icon img-{{ size }}" />
  <img *ngIf="control?.value" [src]="iconService.Icon.check" class="ag-checkbox-checked-icon img-{{ size }}" />
</div>
